import { createAction, props } from '@ngrx/store';

export const loadPaymentRunStatus = createAction(
  '[PaymentRuns] Load PaymentRunStatus',
  props<{ request: { businessId: string; businessPaymentRunId: string; noLoader: boolean } }>()
);

export const loadPaymentRunStatusSuccess = createAction('[PaymentRuns] Load PaymentRunStatus Success', props<{ response: any }>());

export const loadPaymentRunStatusFailure = createAction('[PaymentRuns] Load PaymentRunStatus Failure', props<{ error: Error | any }>());
